import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"
import { useFormContext, useFormFieldProps } from '../../form'

import { FieldError } from '../../../../../widgets'
import { IDropdownProps } from './IDropdownProps'
import React from 'react'
import clsx from 'clsx'
import { useDropdownValidationSchema } from './DropdownValidationSchema'

interface IDropdownFieldProps extends HTMLAttributes<HTMLSelectElement>, IDropdownProps {
    name: string
}

export const DropdownField: FC<IDropdownFieldProps> = React.memo((props) => {
    const { id, name, className, title, disabled, options } = props
    const shape = useDropdownValidationSchema(props)
    const { fieldProps, errors, touched } = useFormFieldProps(name)
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);
        // eslint-disable-next-line
    }, [name, shape])

    return <>
        <select
            title={title}
            id={id}
            disabled={disabled}
            {...fieldProps}
            className={clsx(className, "form-select form-select-sm")}>
            <option></option>
            {options?.map(({ value, label }, i) => <React.Fragment key={i}>
                <option value={value}>{label}</option>
            </React.Fragment>)}
        </select>
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
})
